import { createSlice } from '@reduxjs/toolkit'

const applyViewIncrements = (container, deltas = {}) => {
  if (!container || typeof container !== 'object') return;
  const list = Array.isArray(container.replays) ? container.replays : null;
  if (!list) return;
  list.forEach((entry) => {
    if (!entry) return;
    const entryId = entry.ReplayId || entry.replayId || entry.id;
    if (entryId === undefined || entryId === null) return;
    const delta = deltas[String(entryId)] || 0;
    if (!delta) return;
    if (typeof entry.ViewsCount === 'number') {
      entry.ViewsCount += delta;
    } else if (typeof entry.views === 'number') {
      entry.views += delta;
    } else {
      entry.ViewsCount = delta;
    }
  });
};

export const replaysSlice = createSlice({
  name: 'replays',
  initialState: {
    replays: [{
      name: 'dupa',
      views: 3
    }],
    type: 'latest',
    loaded: false,
    player4Search: null,
    viewIncrements: {},
    filters: {
      player: true,
      replay: false,
      team: false,
      goal: false,
      stadium: false,
      realSoccer: false,
      spaceMode: false,
      searchText: '',
      period: 'week',
      startDate: null,
      endDate: null,
    },
    loadingMore: false,
    allReplaysLoaded: false
  },
  reducers: {
    setReplays: (state, action) => {
      const payload = action.payload || { replays: [] };
      const replayCount = Array.isArray(payload.replays) ? payload.replays.length : 0;
      state.replays = payload
      applyViewIncrements(state.replays, state.viewIncrements);
      if (typeof payload.hasMore === 'boolean') {
        state.allReplaysLoaded = !payload.hasMore
      } else if (replayCount < 10) state.allReplaysLoaded = true
      else state.allReplaysLoaded = false
    },
    addMoreReplays: (state, action) => {
      if (!state.allReplaysLoaded) {
        state.replays = {
          goals: (state.replays.goals || []).concat(action.payload.goals || []),
          matches: (state.replays.matches || []).concat(action.payload.matches || []),
          players: (state.replays.players || []).concat(action.payload.players || []),
          replayId: (state.replays.replayId || []).concat(action.payload.replayId || []),
          replays: (state.replays.replays || []).concat(action.payload.replays || []),
          teams: (state.replays.teams || []).concat(action.payload.teams || []),
          hasMore: action.payload.hasMore
        }
        applyViewIncrements(state.replays, state.viewIncrements);
        if (typeof action.payload.hasMore === 'boolean') {
          state.allReplaysLoaded = !action.payload.hasMore
        } else if (action.payload.replays.length < 10) state.allReplaysLoaded = true
        else state.allReplaysLoaded = false
      }
    },
    setReplaysType: (state, action) => {
      state.type = action.payload
    },
    setReplaysLoaded: (state, action) => {
      state.loaded = action.payload
    },
    setPlayer4Search: (state, action) => {
      state.player4Search = action.payload
    },
    setFilterPlayer: (state, action) => {
      state.filters.player = action.payload
    },
    setFilterTeam: (state, action) => {
      state.filters.team = action.payload
    },
    setFilterReplay: (state, action) => {
      state.filters.replay = action.payload
    },
    setFilterGoal: (state, action) => {
      state.filters.goal = action.payload
    },
    setFilterStadium: (state, action) => {
      state.filters.stadium = action.payload
    },
    setFilterSpaceMode: (state, action) => {
      state.filters.spaceMode = action.payload
    },
    setFilterRealSoccer: (state, action) => {
      state.filters.realSoccer = action.payload
    },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload
    },
    setEndDate: (state, action) => {
      state.filters.endDate = action.payload
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload
    },
    setPeriodState: (state, action) => {
      state.filters.period = action.payload
    },
    setLoadingMore: (state, action) => {
      state.loadingMore = action.payload
    },
    incrementReplayViews: (state, action) => {
      const replayId = String(action.payload);
      if (!replayId) return;
      const current = state.viewIncrements[replayId] || 0;
      state.viewIncrements[replayId] = current + 1;
      applyViewIncrements(state.replays, state.viewIncrements);
    }
  },
})

// Action creators are generated for each case reducer function
export const { setReplays, addMoreReplays, setStartDate, setEndDate, setReplaysType, setReplaysLoaded, setPlayer4Search, setFilterPlayer, setFilterTeam, setFilterReplay, setFilterGoal, setFilterStadium, setFilterSpaceMode, setFilterRealSoccer, setSearchText, setPeriodState, setLoadingMore, incrementReplayViews } = replaysSlice.actions

export default replaysSlice.reducer
